// Auto-generated from translation.csv; do not edit manually
export const zhTW = {
  "accountGuide": {
    "content": "打開任意一款Touka旗下遊戲，前往遊戲內設定介面，綁定你的信箱，即可享受特價商品優惠！",
    "title": "如何創建帳號？"
  },
  "bottomNav": {
    "home": "主頁",
    "myOrders": "我的訂單"
  },
  "common": {
    "loading": "加載中…",
    "noData": "暫無數據",
    "server": "服務器"
  },
  "footer": {
    "language": "中文（簡體）",
    "privacyPolicy": "隱私政策",
    "refundPolicy": "退款政策",
    "termsOfService": "服務條款",
    "userSupport": "用戶支持",
    "downloadNow": "立即下載！"
  },
  "header": {
    "characterName": "角色名稱",
    "gameServer": "遊戲區組",
    "selectGameServer": "請選擇遊戲區組",
    "greeting": "您好",
    "loginPrompt": "請點擊登入",
    "switchServer": "切換",
    "title": "遊戲儲值平台",
    "logout": "登出"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "哎呀！克洛克"
  },
  "history": {
    "backToGameZone": "返回專區",
    "allGames": "全部遊戲",
    "empty": "暫無訂單",
    "filter": {
      "all": "全部",
      "closed": "已關閉",
      "completed": "已完成",
      "inProgress": "進行中",
      "pendingDelivery": "待發貨"
    },
    "orderTime": "下單時間:",
    "pendingAutoCancelPrefix": "訂單將在",
    "pendingAutoCancelSuffix": "後自動取消",
    "cancelOrder": "取消訂單",
    "payOrder": "支付",
    "cancelOrderConfirmTitle": "確認取消訂單？",
    "cancelOrderConfirmPrimary": "確認取消",
    "cancelOrderDismiss": "暫不取消",
    "status": {
      "cancelled": "已取消",
      "completed": "交易完成",
      "paid": "已支付",
      "pending": "待支付",
      "shipped": "已發貨"
    }
  },
  "home": {
    "selectGame": "選擇您要充值的遊戲",
    "selectGameMobileTitle": "選擇充值遊戲",
    "selectGameParts": {
      "prefix": "選擇您要",
      "keyword": "充值",
      "suffix": "的遊戲"
    },
    "noRoleAccount": "您在此遊戲內還沒有角色帳號，請先在遊戲內建立角色後再進行購買。",
    "noRoleRefreshPrefix": "已建立帳號？點選",
    "noRoleRefreshAction": "重新整理",
    "noRoleRefreshing": "重新整理中…",
    "noRoleRefreshNotFound": "查無角色資訊",
    "noRoleRefreshFailed": "重新整理失敗，請稍後再試"
  },
  "login": {
    "agreeTerms": {
      "and": "和",
      "prefix": "我已閱讀並同意",
      "privacy": "隱私政策",
      "terms": "服務條款"
    },
    "cancel": "取消",
    "bindGameGuide": "綁定遊戲須知",
    "bindGameGuideContent": "打開任意一款Touka遊戲，\n前往遊戲內設定頁面，綁定\n你的郵箱，即可享受特價商\n品優惠！",
    "captchaPlaceholder": "驗證碼",
    "invalidCaptcha": "請輸入4位數字驗證碼",
    "email": "郵箱",
    "emailNotBound": "未檢索成功，請輸入遊戲內綁定的郵箱喔~",
    "emailPlaceholder": "請輸入您的電子郵箱",
    "keepLogin": "保持登入狀態 15 天",
    "loading": "登入中...",
    "loginToStore": "登入Touka Store",
    "noAccount": "還沒有帳號？",
    "password": "密碼",
    "passwordPlaceholder": "請輸入密碼",
    "submit": "登入",
    "title": "登入",
    "invalidEmail": "請輸入有效的郵箱地址"
  },
  "logout": {
    "cancel": "取消",
    "confirm": "確認",
    "dontRemind": "下次不再提醒",
    "messageLine1": "退出登入後，近30天內所有設備的",
    "messageLine2": "登入狀態將會失效。",
    "title": "溫馨提示"
  },
  "menu": {
    "contactSupport": "聯繫客服",
    "gameList": "遊戲列表",
    "myOrders": "我的訂單"
  },
  "paymentSuccess": {
    "account": "帳號：",
    "celebrationTitle": "購買成功",
    "confirm": "確定",
    "getPaymentInfoFailed": "獲取支付信息失敗",
    "loading": "加載中...",
    "orderDate": "訂單日期：",
    "orderId": "訂單號：",
    "paymentMethod": "付款方式：",
    "paypal": "PayPal",
    "price": "價格：",
    "purchaseContent": "購買內容：",
    "quantity": "購買數量：",
    "serverAndCharacter": "區組／角色：",
    "title": "感謝您的購買",
    "total": "全部：",
    "unionPay": "銀聯",
    "amountPaid": "實付金額：",
    "closeModal": "關閉"
  },
  "productModal": {
    "confirm": "確定",
    "purchaseDetails": "購買詳情",
    "quantity": "數量：",
    "total": "全部：",
    "unitPrice": "單價："
  },
  "products": {
    "giftPacks": "禮包",
    "diamond": "鑽石",
    "products": "商品",
    "vouchers": "代金券",
    "toukaCoin": "Touka幣",
    "toukaCoinBonusTip": "在TOUKA Store購物，享受額外10%的獎勵！",
    "superValue": "超值",
    "limitShort": "限購",
    "remainingShort": "剩餘時間",
    "giftPackLimitType": {
      "lifetime": "終身特惠",
      "weekly": "週特惠",
      "monthly": "月特惠"
    },
    "howToUseVouchers": "如何使用Touka幣？",
    "voucherGuide": {
      "title": "如何使用Touka幣？",
      "step1": "1.請在遊戲內郵箱查收您購買的Touka幣。",
      "step2": "2.您可以在遊戲商城標籤頁上方查看您的Touka幣數量。當您的Touka幣數量達到購買禮包需要的數量要求時，將優先使用Touka幣進行購買。",
      "backToProducts": "返回商品列表"
    }
  },
  "purchaseConfirm": {
    "card": "信用卡／借記卡",
    "confirm": "確認",
    "dontAskAgain": "30天內不再詢問",
    "gameServer": "遊戲區組",
    "paymentMethods": "支持的支付方式",
    "paypal": "PayPal",
    "title": "您確定通過此帳戶購買嗎",
    "unionPay": "銀聯卡"
  },
  "serverSelect": {
    "characterLabel": "角色名稱",
    "characterPlaceholder": "請選擇角色",
    "confirm": "確定",
    "noResults": "暫無結果",
    "serverPlaceholder": "區服名稱",
    "title": "選擇遊戲區組"
  },
  "support": {
    "cancel": "取消",
    "copied": "已複製",
    "copy": "一鍵複製",
    "description": "請與官方郵件反饋你的詳細信息",
    "title": "客服支持"
  },
  "verification": {
    "back": "返回",
    "enterCode": "請輸入驗證碼以繼續",
    "incorrectCode": "驗證碼不正確",
    "invalidCode": "請輸入6位驗證碼",
    "noCode": "收不到驗證碼？",
    "sentTo": "驗證碼已發送至",
    "submit": "提交",
    "submitting": "提交中..."
  }
} as const;
